'use strict';

module.exports = function () {

    document.body.addEventListener('keyup', function(e) {
        if (e.which === 9 && document.documentElement.classList.contains('no-focus-outline')) { // TAB
            document.documentElement.classList.remove('no-focus-outline');
        }
    });

    document.body.addEventListener('mousedown', function() {
        if (!document.documentElement.classList.contains('no-focus-outline')) {
            document.documentElement.classList.add('no-focus-outline');
        }
    });

};
